import { type ReactNode } from 'react';
import { Flex, Text } from '@servicetitan/anvil2';
import { statusContainer } from './StatusContainer.module.scss';

interface DecisionResultProps {
    image: string;
    headline: string;
    message?: string;
    children?: ReactNode;
}

export const StatusContainer = ({ image, headline, message, children }: DecisionResultProps) => {
    return (
        <Flex
            direction="column"
            alignItems="center"
            gap="8"
            style={{ margin: '0 auto' }}
            className={statusContainer}
        >
            <Flex alignItems="center" direction="column" gap="4">
                <img src={image} />
                <Text variant="headline" el="h2" style={{ textAlign: 'center', marginBlockEnd: 0 }}>
                    {headline}
                </Text>
                {message && <Text style={{ textAlign: 'center' }}>{message} </Text>}{' '}
            </Flex>
            {children}
        </Flex>
    );
};
